import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid2 as Grid, Stack} from 'views/components';

import FilterBar from './scene/filter/FilterBar';
import Header from './scene/Header';
import List from './scene/list/List';
import {generateFilterOptions} from './scene/filter/FilterGenerator';

import JOB_SOURCES from '../job_source';

const defaultSelection = (filterOptions) => {
  return {
    order: {orderBy: 'creationTime', orderDirc: 'DESC'},
    sortByPriority: true,
    filter: {
      status: {
        filterData: filterOptions['status'],
        optionSelected: 'ACTIVE',
      },
    },
  };
};

const JobList = (props) => {
  const jobSource = props.jobSource || JOB_SOURCES.LEGACY;
  const filterOptions = React.useMemo(
      () => generateFilterOptions(jobSource.supportsJobTypeFilter),
      [jobSource],
  );
  const [reload, setReload] = React.useState(0);
  const [lastUpdatedAt, setLastUpdatedAt] = React.useState(new Date());
  const [selection, setSelection] = React.useState(() => defaultSelection(filterOptions));

  const resetFilter = () => {
    setSelection(defaultSelection(filterOptions));
  };

  const updateFilter = (filter, option) => {
    setSelection((e) => {
      const newFilter = {...e.filter};

      if (option) {
        newFilter[filter.key] = {
          filterData: filter,
          optionSelected: option.key,
        };
      } else {
        delete newFilter[filter.key];
      }

      return {
        ...e,
        sortByPriority: filter.key === 'status' ? option?.key === 'ACTIVE' : e.sortByPriority,
        filter: newFilter,
      };
    });
  };

  const togglePrioritySort = (enabled) => {
    setSelection((e) => {
      return {
        ...e,
        sortByPriority: enabled,
      };
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <Header
          lastUpdatedAt={lastUpdatedAt}
          numRefresh={reload}
          setLastUpdatedAt={setLastUpdatedAt}
          setNumRefresh={setReload}
        />
      </Grid>
      <Grid size={12}>
        <Stack spacing={4} width={1} pb={{xs: 0, md: 2}}>
          <FilterBar
            selection={selection}
            filterOptions={filterOptions}
            updateFilter={updateFilter}
            onClearFilter={resetFilter}
            onTogglePrioritySort={togglePrioritySort}
          />
          <List
            selection={selection}
            reload={reload}
            jobSource={jobSource}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};
JobList.propTypes = {
  jobSource: PropTypes.object,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(JobList));
